import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW9006Model } from '../kymw9006.model';

/**
 * ユーザ権限情報を取得する。
 *
 * @export API通信成功時の処理
 * @class UpdatePasswordService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdatePasswordService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9006Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdatePasswordService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        updatePassword: {
          condition: {
            UserId: this.model.userId,
            Password: this.model.password,
            NewPassword: this.model.newPassword,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9000Model} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof UpdatePasswordService
   */
  execute(model: KYMW9006Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('updatePassword', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdatePasswordService
   */
  success(data: any) {
    if ( this.successFunc !== null ) {
      this.successFunc();
    }
  }
}
